import { render, staticRenderFns } from "./ResultadoPorStatus.vue?vue&type=template&id=0e6cbaf4"
import script from "./ResultadoPorStatus.vue?vue&type=script&lang=ts"
export * from "./ResultadoPorStatus.vue?vue&type=script&lang=ts"
import style0 from "./ResultadoPorStatus.vue?vue&type=style&index=0&id=0e6cbaf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports